import React from "react";

const RecurrenceSection = ({
  formData,
  handleFieldChange,
  daysOfWeek,
  monthOfYear,
  toggleDaySelection,
  handleDayValidation,
}) => {
  console.log("formDatarecurr", formData.day_of_month);
  const hideArrowClass =
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";

  switch (formData?.frequency) {
    case "daily":
      return (
        <div className="flex flex-col gap-1 text-[#434852]">
          <div className="flex gap-2 py-2 items-center">
            <div>
              <input
                type="radio"
                name="daily_option"
                value={"every_n_days"}
                className="radio  checked:border-primary checked:bg-primary-90 ring-0 focus:ring-0 focus:outline-none"
                checked={formData?.daily_option === "every_n_days"}
                onChange={handleFieldChange}
              />
            </div>
            <div className="text-sm">Every</div>

            <div className="appearance-none px-2 w-10 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
              <input
                type="number"
                id="intervals"
                name="intervals"
                value={formData?.intervals}
                onChange={(e) => {
                  const value = e.target.value;
                  if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                    handleFieldChange(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (!value || Number(value) < 1) {
                    handleFieldChange({ target: { name: "intervals", value: "1" } });
                  }
                }}
                className={`w-16 p-0 bg-transparent border-0 focus:ring-0 dark:text-white disabled:opacity-50 disabled:bg-[#EBEBE4]  ${hideArrowClass} `}
                placeholder=""
                required
                disabled={formData?.daily_option === "every_weekday"}
                min={1}
              />
            </div>
            <div className="text-sm">{Number(formData?.intervals) === 1 ? "Day" : "Days"}</div>
          </div>
          <div className="flex items-center gap-2 ">
            <div>
              <input
                type="radio"
                name="daily_option"
                value={"every_weekday"}
                className="radio  checked:border-primary checked:bg-primary-90 ring-0 focus:ring-0 focus:outline-none"
                onChange={handleFieldChange}
                checked={formData?.daily_option === "every_weekday"}
              />
            </div>
            <div className="text-sm">Every Weekdays</div>
          </div>
        </div>
      );
    case "weekly":
      return (
        <div>
          <div className="flex items-center gap-1.5">
            <div className="text-sm">Recur every</div>

            <div className="appearance-none pb-5 px-2 w-10 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
              <input
                type="number"
                name="intervals"
                value={formData?.intervals}
                onChange={(e) => {
                  const value = e.target.value;
                  if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                    handleFieldChange(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (!value || Number(value) < 1) {
                    handleFieldChange({ target: { name: "intervals", value: "1" } });
                  }
                }}
                className={`w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white ${hideArrowClass} `}
                min={1}
              />
            </div>

            <div className="items-center text-sm"> week(s) on:</div>
          </div>

          {/*<div className="gap-2 flex flex-grow">
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Sun
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Mon
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Tue
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Wed
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Thu
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Fri
              </button>
              <button
                type="button"
                id="toggleButton"
                className=" text-xs font-normal hover:bg-sky-950 hover:text-white focus:bg-sky-950 focus:text-white items-center p-2 px-4 border rounded"
              >
                Sat
              </button>
            </div>
            */}

          <div className="gap-2 flex flex-grow flex-wrap py-3 justify-start">
            {daysOfWeek.map((day, index) => (
              <button
                key={index}
                type="button"
                className={`w-[58px] h-[27px] text-xs font-normal items-center border rounded-md ${
                  formData?.weekly_days?.includes(day)
                    ? "bg-primary-90 text-white"
                    : "hover:bg-primary hover:text-white focus:bg-primary-90 focus:text-white"
                }`}
                onClick={() => toggleDaySelection(day)}
              >
                {day?.slice(0, 3)}
              </button>
            ))}
          </div>
        </div>
      );
    case "monthly":
      return (
        <div>
          <div className="flex flex-nowrap gap-1 py-2 items-center">
            <div>
              <input
                type="radio"
                name="monthly_option"
                value={"specific_day"}
                className="radio  checked:border-primary checked:bg-primary-90"
                checked={formData?.monthly_option === "specific_day"}
                onChange={handleFieldChange}
              />
            </div>
            <div className="text-sm text-[#434852]">Day</div>

            <div className="appearance-none px-2 w-9 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-[#434852] text-sm block">
              <input
                type="number"
                id="day_of_month"
                name="day_of_month"
                value={formData?.day_of_month}
                onChange={handleFieldChange}
                className={`w-16 p-0 bg-transparent border-0 text-[#434852] focus:ring-0 dark:text-white  ${hideArrowClass}`}
                placeholder="00"
                onKeyUp={handleDayValidation}
                required
                min={1}
                max={31}
              />
            </div>

            <div className="text-sm text-[#434852]">Of Every</div>

            <div className="appearance-none px-2 w-9 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-[#434852] text-sm block">
              <input
                type="number"
                id="intervals"
                name="intervals"
                value={formData?.intervals}
                onChange={(e) => {
                  const value = e.target.value;
                  if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                    handleFieldChange(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (!value || Number(value) < 1) {
                    handleFieldChange({ target: { name: "intervals", value: "1" } });
                  }
                }}
                className={`p-0 bg-transparent border-0 text-[#434852] focus:ring-0 dark:text-white ${hideArrowClass}`}
                placeholder="00"
                min={1}
                max={12}
                // onKeyUp={() => { }}
                onKeyUp={(e) => {
                  const value = e.target.value;

                  if (Number(value) < 1 || Number(value) > 12) {
                    e.target.value = value.slice(0, -1);
                  }
                }}
                required
                // min={1}
              />
            </div>

            <div className="text-sm text-[#434852]">Month(s)</div>
          </div>

          {false && (
            <div className="flex gap-2 py-2 items-center">
              <div>
                <input
                  type="radio"
                  name="monthly_option"
                  value={"weekday_of_month"}
                  className="radio appearance-none  checked:border-primary checked:bg-primary-90"
                  checked={formData?.monthly_option === "weekday_of_month"}
                  onChange={handleFieldChange}
                />
              </div>
              <div className="text-xs">The</div>

              <div className="flex items-center justify-end">
                <select
                  id={`monthly_week`}
                  name="monthly_week"
                  onChange={handleFieldChange}
                  value={formData?.monthly_week}
                  className={`custom-select flex bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs w-full pr-10`}
                >
                  <option value="first">First</option>
                  <option value="second">Second</option>
                  <option value="third">Third</option>
                  <option value="fourth">Fourth</option>
                </select>
                <div className="absolute flex px-2 pointer-events-none">
                  {/* <h4>
                    <i className="bi bi-chevron-down"></i>
                  </h4> */}
                </div>
              </div>
              {/* {formErrors?.recurr_pattern && (
                <span className="text-red-500 text-xs">
                  Cannot be left blank.
                </span>
              )} */}

              <div className="flex items-center justify-end">
                <select
                  id={`day_of_week`}
                  name="day_of_week"
                  onChange={handleFieldChange}
                  value={formData?.day_of_week}
                  className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full py-1 pr-10`}
                >
                  {daysOfWeek.map((day, index) => (
                    <option key={index} value={day?.toLowerCase()}>
                      {day}
                    </option>
                  ))}
                </select>
                <div className="absolute flex px-2 pointer-events-none">
                  {/* <h4>
                    <i className="bi bi-chevron-down"></i>
                  </h4> */}
                </div>
              </div>
              {/* {formErrors.recurr_pattern && (
                <span className="text-red-500 text-xs">
                  Cannot be left blank.
                </span>
              )} */}

              <div className="text-xs">Of Every</div>

              <div className="appearance-none pb-5 px-3 w-20 h-8 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block ">
                <input
                  type="number"
                  id="intervals"
                  name="intervals"
                  value={formData?.intervals}
                  onChange={(e) => {
                    const value = e.target.value;
                    if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                      handleFieldChange(e);
                    }
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (!value || Number(value) < 1) {
                      handleFieldChange({ target: { name: "intervals", value: "1" } });
                    }
                  }}
                  className="w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
                  placeholder=""
                  required
                  min={1}
                />
              </div>

              <div className="text-xs">Month &#40; s &#41;</div>
            </div>
          )}
        </div>
      );
    case "yearly":
      return (
        <div>
          <div className="flex gap-2 py-2 items-center">
            <div className="text-xs">
              Re<u>c</u>ur every
            </div>

            <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
              <input
                type="number"
                id="intervals"
                name="intervals"
                value={formData?.intervals}
                onChange={(e) => {
                  const value = e.target.value;
                  if ((/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 10000) || value === "") {
                    handleFieldChange(e);
                  }
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (!value || Number(value) < 1) {
                    handleFieldChange({ target: { name: "intervals", value: "1" } });
                  }
                }}
                className="w-16 p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
                placeholder=""
                required
                min={1}
              />
            </div>
            <div className="text-xs">year(s)</div>
          </div>
          <div className="flex gap-2 py-2 items-center">
            <div>
              <input
                type="radio"
                name="yearly_option"
                value={"specific_year"}
                className="radio  checked:border-primary checked:bg-primary-90"
                checked={formData?.yearly_option === "specific_year"}
                onChange={handleFieldChange}
              />
            </div>
            <div className="text-xs">On </div>

            <select
              id={`recurr_pattern_days`}
              name="recurr_pattern_days"
              // onChange={handleRecurChange}
              className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block  h-9 appearance-none pr-10`}
            >
              {monthOfYear.map((month, index) => (
                <option key={index} value={month}>
                  {month}
                </option>
              ))}
            </select>

            <div className="appearance-none pb-5 px-3 w-20 h-9 bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block">
              <input
                type="number"
                id="visitors"
                className="w-16  p-0 bg-transparent border-0 text-gray-800 focus:ring-0 dark:text-white"
                placeholder=""
                required
                defaultValue={1}
                min={1}
              />
            </div>
          </div>

          <div className="flex gap-2 py-2 items-center">
            <div>
              <input
                type="radio"
                name="yearly_option"
                value={"weekday_of_year"}
                className="radio  checked:border-primary checked:bg-primary-90 "
                checked={formData?.yearly_option === "weekday_of_year"}
                onChange={handleFieldChange}
              />
            </div>
            <div className="text-xs">On The</div>

            <div className="flex items-center justify-end">
              <select
                id={`recurr_pattern_times`}
                name="recurr_pattern_times"
                // onChange={handleRecurChange}
                className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full h-9 appearance-none pr-10`}
              >
                <option value="First">First</option>
                <option value="Second">Second</option>
                <option value="Third">Third</option>
              </select>
              <div className="absolute flex px-2 pointer-events-none">
                <h4>
                  <i className="bi bi-chevron-down"></i>
                </h4>
              </div>
            </div>
            {/* {formErrors.recurr_pattern && (
                <span className="text-red-500 text-xs">
                  Cannot be left blank.
                </span>
              )} */}

            <div className="flex items-center justify-end">
              <select
                id={`recurr_pattern_days`}
                name="recurr_pattern_days"
                // onChange={handleRecurChange}
                className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full h-9 appearance-none pr-10`}
              >
                {daysOfWeek.map((day, index) => (
                  <option key={index} value={day}>
                    {day}
                  </option>
                ))}
              </select>
              <div className="absolute flex px-2 pointer-events-none">
                <h4>
                  <i className="bi bi-chevron-down"></i>
                </h4>
              </div>
            </div>
            {/* {formErrors.recurr_pattern && (
                <span className="text-red-500 text-xs">
                  Cannot be left blank.
                </span>
              )} */}

            <div className="text-xs">Of Every</div>

            <select
              id={`recurr_pattern_days`}
              name="recurr_pattern_days"
              // onChange={handleRecurChange}
              className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block  h-9 appearance-none pr-10`}
            >
              {monthOfYear.map((month, index) => (
                <option key={index} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default RecurrenceSection;
